import AdminMemos from './AdminMemos';

export default AdminMemos;
